import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

function UIUX() {
const [openIndex, setOpenIndex] = useState<number | null>(0);

const toggleAccordion = (index: number) => {
setOpenIndex(openIndex === index ? null : index);
};

const services = [
  {
    title: "Website Strategy & Information Architecture",
    content:
      "A great website starts with a solid structure. We plan website strategies and information architecture that prioritize user journeys, clarity, and business objectives. By mapping content flows and navigation, we ensure visitors find what they need quickly and intuitively. This foundation improves usability, engagement, and conversion rates across devices.",
  },
  {
    title: "UI/UX Design",
    content:
      "User experience defines brand perception in the digital world. We design intuitive, user-centric interfaces that balance aesthetics with functionality. Our UI/UX process involves research, wireframing, prototyping, and usability testing to ensure seamless interactions. The result is digital experiences that are easy to use, visually appealing, and designed to convert users into customers.",
  },
  {
    title: "Website Design & Development",
    content:
      "We design and develop responsive, high-performance websites that reflect brand identity and business goals. From corporate websites to landing pages, our solutions are optimized for speed, security, and scalability. We ensure seamless integration of design, content, and technology to deliver websites that look great and perform flawlessly across devices.",
  },
  {
    title: "E-commerce Experiences",
    content:
      "We create user-friendly e-commerce platforms that make online shopping effortless. From product discovery and intuitive navigation to secure checkout experiences, we focus on maximizing conversions while enhancing customer satisfaction. Our e-commerce solutions are built to scale, support business growth, and deliver seamless purchasing journeys.",
  },
  {
    title: "Mobile App UI/UX Design",
    content:
      "Mobile experiences demand simplicity and speed. We design intuitive mobile app interfaces that deliver seamless user journeys while aligning with brand aesthetics. From onboarding flows to feature navigation, our designs focus on usability, engagement, and retention—ensuring apps are both functional and delightful to use.",
  },
  {
    title: "Digital Product & Experience Design",
    content:
      "We design end-to-end digital experiences for platforms, tools, and SaaS products. By combining strategy, UX thinking, and visual design, we create products that solve real user problems. Our approach ensures scalability, consistency, and ease of use—helping brands deliver meaningful digital experiences that drive adoption and loyalty.",
  },
];


return (


<>
  <Header />

  <section
    className="container"
    style={{
      paddingTop: "80px",
      paddingBottom: "80px",
    }}
    >
    <p
        style={{
          marginTop: "20px",
          fontSize: "16px",
          color: "#888",
        }}
      >
        <Link to="/" style={{ color: "#111", textDecoration: "none" }}>
          Home
        </Link>

        {" / "}

        <Link
          to="/services"
          style={{ color: "#111", textDecoration: "none" }}
        >
          Services
        </Link>

        {" / "}Web, UI/UX & Digital Experiences
      </p>
  
    <h1
      style={{
        marginTop: "40px",
        fontSize: "80px",
        lineHeight: "1.1",
        marginBottom: "100px",
      }}
    >
      <span style={{ fontWeight: "400" }}>
        Web, UI/UX &
      </span>

      <br />

      <span style={{ fontWeight: "100" }}>
        Digital
      </span>
      <span style={{ fontWeight: "700" }}>
    Experience
  </span>
    </h1>
    <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginTop: "40px",
    marginBottom: "90px",
  }}
>
  <span
    style={{
      fontSize: "20px",
      fontWeight: "400",
      color: "#111",
    }}
  >
    About service
  </span>

  <a
    href="#about-service"
    style={{
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "24px",
    }}
  >
    ↓
  </a>
</div>
  
    <div className="row">
      <div className="col-lg-5">
        <h2
          style={{
            fontSize: "40px",
            lineHeight: "1.1",
            marginBottom: "40px",
          }}
>
          <strong>Your</strong> Approach
          <br />
          <strong>and</strong> Work Specifics
          </h2>

        <p
          style={{
            color: "#777",
            lineHeight: "1.6",
            fontSize: "17px",
          }}
        >
         Our campaigns are driven by strong ideas and sharp storytelling.
We develop concepts and advertising strategies across digital,
print, outdoor, video, and brand experiences. Every campaign is
crafted to cut through the clutter, connect emotionally, and
deliver measurable brand impact.
        </p>
        <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginTop: "40px",
  }}
>
  <span
    style={{
      fontSize: "24px",
      fontWeight: "400",
      color: "#111",
    }}
  >
    View works
  </span>

  <a
    href="/portfolio"
    style={{
      width: "58px",
      height: "58px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "20px",
    }}
  >
    →
  </a>
</div>
      </div>

      <div className="col-lg-6 offset-lg-1">
        {services.map((service, index) => (
          <div key={index}>
            <div
              onClick={() => toggleAccordion(index)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                padding: "25px 0",
              }}
            >
              <h4
                style={{
                  margin: 0,
                  fontSize: "18px",
                }}
              >
                {service.title}
              </h4>
<div
  style={{
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: openIndex === index ? "#ff9800" : "#efefef",
    color: openIndex === index ? "#000" : "#666",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    fontWeight: "300",
    transition: "all 0.3s ease",
  }}
>
  {openIndex === index ? "−" : "+"}
</div>

            </div>

            {openIndex === index && (
              <p
                style={{
                  color: "#777",
                  lineHeight: "1.5",
                  fontSize: "14px",
                  paddingBottom: "25px",
                }}
              >
                {service.content}
              </p>
            )}

            <hr />
          </div>
        ))}
      </div>
    </div>
  </section>
  <section
  style={{
    background: "#000",
    color: "#fff",
    padding: "120px 0",
    textAlign: "center",
    position: "relative",
  }}
>
  <div className="container">

    <h2
      style={{
        fontSize: "50px",
        lineHeight: "1.1",
        marginBottom: "30px",
      }}
    >
      <span style={{ fontWeight: "100", color: "#fff" }}>
        Where
      </span>{" "}
      <span style={{ fontWeight: "500", color: "#fff" }}>
        Creativity
      </span>{" "}
      <span style={{ fontWeight: "100", color: "#fff" }}>
        Meets
      </span>

      <br />

      <span style={{ fontWeight: "500", color: "#fff" }}>
        Strategic Execution
      </span>
    </h2>

    <p
      style={{
        maxWidth: "900px",
        margin: "0 auto 50px",
        color: "#bdbdbd",
        fontSize: "20px",
        lineHeight: "1.8",
      }}
    >
      Explore and gain a deeper understanding of the comprehensive
      range of services we offer, thoughtfully designed to meet your
      needs and deliver impactful, results-driven solutions across
      every stage of your business journey.
    </p>

    <a
      href="/contact"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "20px",
        background: "#ce5311",
        color: "#000",
        textDecoration: "none",
        padding: "20px 35px",
        borderRadius: "50px",
        fontWeight: "600",
        fontSize: "18px",
      }}
    >
      Contact Us

      <span
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          background: "#000",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        →
      </span>
    </a>

  </div>
</section>
<section
  style={{
    padding: "120px 0",
    background: "#f5f5f5",
  }}
>
  <div className="container">

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "50px",
      }}
    >
      <h2 style={{ 
        margin: 0,
    fontSize: "36px",
    lineHeight: "1.1",
       }}>Other Services</h2>

      <a
        href="/services"
        style={{
          textDecoration: "none",
          color: "#111",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        View all
        <span
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "50%",
            background: "#e5e5e5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          →
        </span>
      </a>
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "30px",
      }}
    >

      {/* Card 1 */}
     {/* Card 1 */}
<div className="service-card">

  <h3 style={{
      marginBottom: "30px",
  fontSize: "30px",
  lineHeight: "1.1",
  }}>
     Branding & Identity Design
  </h3>

  <p style={{ lineHeight: "1.8", marginBottom: "30px", fontSize: "14px" }}>
    Creating impactful brand identities that inspire
    recognition, differentiation, and long-term market distinction.
  </p>

  <hr />
  <p 
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
    }}>Brand Strategy & Positioning </p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Logo Design & Visual Identity</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Brand Guidelines & Playbooks</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Packaging & Label Design</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Rebranding & Brand Refresh</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Naming & Brand Architecture</p>

  <a
    href="/branding"
    style={{
      marginTop: "40px",
      display: "inline-flex",
      alignItems: "center",
      gap: "15px",
      textDecoration: "none",
      color: "#111",
      fontWeight: "600",
    }}
  >
    Read more
    <span className="read-more-circle">→</span>
  </a>
</div>

{/* Card 2 */}
<div className="service-card">

  <h3 style={{
      marginBottom: "30px",
  fontSize: "30px",
  lineHeight: "1.1",
   }}>
    Creative Advertising & Campaigns
  </h3>

  <p style={{ lineHeight: "1.8", marginBottom: "30px", fontSize: "14px" }}>
    Building compelling multi-channel campaigns that spark
    attention, drive engagement, and influence customer behaviour.
  </p>

  <div >
    <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Creative Concept Development</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Integrated Advertising Campaigns</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Print & Outdoor Advertising</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Brand Films & Video Content</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Event & Experiential Creative</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Content & Copywriting</p>
</div>
  <a
    href="/campaigns"
    style={{
      marginTop: "40px",
      display: "inline-flex",
      alignItems: "center",
      gap: "15px",
      textDecoration: "none",
      color: "#111",
      fontWeight: "600",
    }}
  >
    Read more
    <span className="read-more-circle">→</span>
  </a>
</div>

{/* Card 3 */}
<div className="service-card">

  <h3 style={{ 
      marginBottom: "30px",
  fontSize: "30px",
  lineHeight: "1.1",
  }}>
    Digital Marketing & Performance Growth
  </h3>

  <p style={{ lineHeight: "1.8", marginBottom: "30px" , fontSize: "14px"}}>
    Driving measurable growth through targeted digital strategies,
    content, and performance-focused marketing solutions.
  </p>

  <hr />
  <p 
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Social Media Marketing & Management</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Performance Marketing & Paid Media</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
  >Search Engine Optimization (SEO)</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Content Marketing Strategy</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Email & Marketing Automation</p>
  <hr />
  <p
  style={{
    margin: "14px 0",
    lineHeight: "1.6",
    color: "#111",
    fontSize: "14px",
  }}
>Analytics, Insights & Optimization</p>

  <a
    href="/digital-marketing"
    style={{
      marginTop: "40px",
      display: "inline-flex",
      alignItems: "center",
      gap: "15px",
      textDecoration: "none",
      color: "#111",
      fontWeight: "600",
    }}
  >
    Read more
    <span className="read-more-circle">→</span>
  </a>
</div>

    </div>
  </div>
</section>

  <Footer />
</>

);
}

export default UIUX;